
import ConfirmPageContainer from '@pleinair/bigcolony-vue/components/cart/confirm/Container.vue'

export default {
  name: 'OrderConfirmationPage',
  components: {
    ConfirmPageContainer,
  },
  head() {
    return this.$utils.head(this.story)
  },
}
